import { SVGProps } from 'react';

const Ham = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.856 10.856c-.819.819-1.062 2.146-.676 3.69.386 1.543 1.369 3.177 2.733 4.54 1.364 1.365 2.998 2.348 4.541 2.734s2.871.143 3.69-.676c.97-.97 1.797-2.064 2.435-3.218.638-1.155 1.073-2.348 1.281-3.512.208-1.163.186-2.274-.067-3.27-.253-.995-.731-1.855-1.407-2.53-.675-.676-1.535-1.154-2.53-1.407-.996-.253-2.107-.276-3.27-.067-1.164.208-2.357.643-3.512 1.28a14.5 14.5 0 0 0-3.218 2.436m10.288 10.288c.819-.819 1.062-2.146.676-3.69-.386-1.543-1.369-3.177-2.733-4.54-1.365-1.365-2.998-2.348-4.542-2.734s-2.87-.143-3.69.676m13.71-.42L18.6 8.4a2.501 2.501 0 1 0 1.65-4.65 2.5 2.5 0 1 0-4.66 1.66l-2.024 2.025M8.5 16.5l-1-1"
    />
  </svg>
);
export default Ham;
